import { SharedAngular } from '@Client/@types/sharedAngular';
import { Guid } from '@Shared.Angular/@types/guid';
import angular from 'angular';
import { IStateProvider } from 'angular-ui-router';

angular.module('flowingly.runner.reportsv2').config(config);

config.$inject = ['$stateProvider'];

function config($stateProvider: IStateProvider) {
  $stateProvider.state('app.runner.reportsv2', {
    url: 'reportsv2',
    params: { title: 'Reports' },
    templateUrl: 'Client/runner.reportsv2/runner.reportsv2.tmpl.html',
    controller: RunnerReportsV2Controller,
    controllerAs: 'ctrl'
  });
}

class RunnerReportsV2Controller {
  static $inject = ['brandingService', 'pubsubService', '$scope', '$state'];

  helpUri: string;
  subscriberId = 'ReportsV2Controller';

  constructor(
    private brandingService: SharedAngular.BrandingService,
    private pubsubService: SharedAngular.PubSubService,
    private $scope: angular.IScope,
    private $state: angular.ui.IStateService
  ) {
    this.helpUri = this.brandingService.getBrandedHelpUri(
      'https://help.flowingly.net/getting-started/how-do-i-run-a-report'
    );

    this.pubsubService.subscribe(
      'WORKFLOW_REPORT_CLICKED',
      (eventName: string, flowModelId: Guid) => {
        this.$state.go('app.runner.report', { flowModelId });
      },
      this.subscriberId
    );
    this.$scope.$on('$destroy', () => {
      this.pubsubService.unsubscribeAll(this.subscriberId);
    });
  }
}
